import "./styles.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AuthProvider from "./AuthProvider";



import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <AuthProvider>
        <App />
    </AuthProvider>
)

// const root = ReactDOM.createRoot(document.getElementById("root"));
// // <ReactKeycloakProvider authClient={keycloak} initOptions={{ onLoad: "login-required" }}>
// // </ReactKeycloakProvider>
//
// root.render(
// <AuthProvider>
//     <App />
// </AuthProvider>
//
// );

